import styled, { css } from "styled-components"

const Content = styled.aside`
  color: #637381;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  transition: all 0.45s ease-out;
  opacity: 1;
  max-height: 2000px;
  opacity: 1;
  margin-bottom: 20px;
  ${({ expand }) =>
    !expand &&
    css`
      height: 0;
      margin: 0;
      opacity: 0;
      max-height: 0;
      overflow: hidden;
    `}

  @media(max-width:768px) {
    font-size: 16px;

    thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    tr {
      height: auto;
      border-bottom: 2px solid #ddd;
      display: block;
      margin-bottom: 1.625em;
      background-color: rgba(0, 0, 0, 0.01);
    }

    td {
      border-bottom: 1px solid #ddd;
      display: block;
      font-size: 0.8em;
      text-align: right;
      line-height: 30px;
    }

    td::before {
      /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
      content: attr(data-th);
      float: left;
      font-weight: bold;
      text-transform: uppercase;
    }

    td:last-child {
      border-bottom: 0;
    }
  }
`
export default Content
